import React, { useEffect, useState } from 'react';
import constantContactAPI from '../utils/constantContact';

const OAuthCallback = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing authorization...');
  const navigateToQuiz = () => window.location.assign('/');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');

        if (error) {
          throw new Error(`Authorization failed: ${error}`);
        }

        if (!code || !state) {
          throw new Error('Missing authorization code or state parameter');
        }

        setMessage('Exchanging authorization code for access token...');
        
        // Exchange code for tokens
        await constantContactAPI.exchangeCodeForToken(code, state);
        
        setMessage('Testing connection...');
        
        // Test the connection
        await constantContactAPI.testConnection();
        
        setStatus('success');
        setMessage('Successfully connected to Constant Contact!');
        
        // Redirect back to admin or wherever appropriate
        setTimeout(() => {
          navigateToQuiz();
        }, 2000);
        
      } catch (error) {
        console.error('OAuth callback error:', error);
        setStatus('error');
        setMessage(`Error: ${error.message}`);
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
        <div className="text-center">
          {status === 'processing' && (
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          )}
          
          {status === 'success' && (
            <div className="text-green-600 text-5xl mb-4">✓</div>
          )}
          
          {status === 'error' && (
            <div className="text-red-600 text-5xl mb-4">✗</div>
          )}
          
          <h2 className="text-xl font-semibold mb-2">
            {status === 'processing' && 'Connecting to Constant Contact'}
            {status === 'success' && 'Connection Successful'}
            {status === 'error' && 'Connection Failed'}
          </h2>
          
          <p className="text-gray-600 mb-4">{message}</p>
          
          {status === 'error' && (
            <button
              onClick={navigateToQuiz}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Back to Quiz
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OAuthCallback;
